import React from "react";

/**
 * Debug Component
 * Displays calculated variables for debugging and inspection
 */
const Debug = (props) => {
  return (
    <div className="page-content header-clear-medium">
      <div className="card card-style contact-form">
        <div className="content">
          <table className="table">
            <tbody>
              <tr>
                <td>Tracelength</td>
                <td>{props.uservariables["Tracelength"]}</td>
              </tr>
              {Object.keys(props.uservariables).map((uservariable, index) => (
                <tr key={index}>
                  <td>{uservariable}</td>
                  <td>{props.uservariables[uservariable]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Debug;






